var _defs, _rect, _text, _text2, _g, _line, _polygon, _g2, _line2, _line3, _line4, _g3, _g4, _g5, _line5, _polygon2, _text3, _line6, _text4, _g6, _g7, _line7, _polygon3, _line8, _polygon4, _g8, _g9, _text5, _text6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchitecture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1100 920",
    fontFamily: "'Segoe UI', Arial, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0c0c1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#16162a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edge",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1e3a5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0f2744"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "product",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#312e81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1e1b4b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "outbound",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#065f46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#064e3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vendor",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3f3f46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#27272a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 6,
    floodColor: "#000",
    floodOpacity: 0.35
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1100,
    height: 920,
    rx: 24,
    fill: "url(#bg)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fill: "#e2e8f0",
    fontSize: 22,
    fontWeight: 700
  }, "Outbound path in QuickStart AI")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 80,
    fill: "#94a3b8",
    fontSize: 14
  }, "Public clients stop at the gateway. Vendor keys live only in the two green services.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 110,
    width: 380,
    height: 64,
    rx: 12,
    fill: "url(#edge)",
    stroke: "#60a5fa",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 138,
    fill: "#f8fafc",
    fontSize: 16,
    fontWeight: 700,
    textAnchor: "middle"
  }, "Browser / API client"), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 158,
    fill: "#bfdbfe",
    fontSize: 13,
    textAnchor: "middle"
  }, "Never calls OpenAI, Anthropic, or scrape vendors"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 550,
    y1: 174,
    x2: 550,
    y2: 206,
    stroke: "#64748b",
    strokeWidth: 2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "544,206 556,206 550,216",
    fill: "#64748b"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 220,
    width: 500,
    height: 78,
    rx: 12,
    fill: "url(#edge)",
    stroke: "#38bdf8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 250,
    fill: "#f8fafc",
    fontSize: 16,
    fontWeight: 700,
    textAnchor: "middle"
  }, "API Gateway :3000"), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 274,
    fill: "#bae6fd",
    fontSize: 13,
    textAnchor: "middle"
  }, "JWT \uFFFD workspace membership \uFFFD Redis rate limit"))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 298,
    x2: 180,
    y2: 348,
    stroke: "#64748b",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 550,
    y1: 298,
    x2: 550,
    y2: 348,
    stroke: "#64748b",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 298,
    x2: 920,
    y2: 348,
    stroke: "#64748b",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 352,
    width: 280,
    height: 92,
    rx: 12,
    fill: "url(#product)",
    stroke: "#a78bfa",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 386,
    fill: "#f8fafc",
    fontSize: 15,
    fontWeight: 700,
    textAnchor: "middle"
  }, "Runtime :3006"), /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 408,
    fill: "#ddd6fe",
    fontSize: 13,
    textAnchor: "middle"
  }, "Agent turn loop"), /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 428,
    fill: "#c4b5fd",
    fontSize: 12,
    textAnchor: "middle"
  }, "No vendor SDK"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 352,
    width: 280,
    height: 92,
    rx: 12,
    fill: "url(#product)",
    stroke: "#a78bfa",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 386,
    fill: "#f8fafc",
    fontSize: 15,
    fontWeight: 700,
    textAnchor: "middle"
  }, "Knowledge :3009"), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 408,
    fill: "#ddd6fe",
    fontSize: 13,
    textAnchor: "middle"
  }, "RAG API"), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 428,
    fill: "#c4b5fd",
    fontSize: 12,
    textAnchor: "middle"
  }, "Own failure policy"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 352,
    width: 280,
    height: 92,
    rx: 12,
    fill: "url(#product)",
    stroke: "#a78bfa",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 386,
    fill: "#f8fafc",
    fontSize: 15,
    fontWeight: 700,
    textAnchor: "middle"
  }, "Memory :3010"), /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 408,
    fill: "#ddd6fe",
    fontSize: 13,
    textAnchor: "middle"
  }, "Per-user facts"), /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 428,
    fill: "#c4b5fd",
    fontSize: 12,
    textAnchor: "middle"
  }, "Own failure policy"))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 444,
    x2: 280,
    y2: 510,
    stroke: "#34d399",
    strokeWidth: 2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "272,500 292,512 276,520",
    fill: "#34d399"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 168,
    y: 490,
    fill: "#6ee7b7",
    fontSize: 12
  }, "POST /internal/complete")), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 550,
    y1: 444,
    x2: 780,
    y2: 510,
    stroke: "#94a3b8",
    strokeWidth: 1.5,
    strokeDasharray: "5 4"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 478,
    fill: "#94a3b8",
    fontSize: 12
  }, "ingest / future tools")), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 520,
    width: 420,
    height: 110,
    rx: 12,
    fill: "url(#outbound)",
    stroke: "#34d399",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 554,
    fill: "#f8fafc",
    fontSize: 16,
    fontWeight: 700,
    textAnchor: "middle"
  }, "model-gateway :3005"), /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 578,
    fill: "#d1fae5",
    fontSize: 13,
    textAnchor: "middle"
  }, "Adapters + orchestrator"), /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 600,
    fill: "#a7f3d0",
    fontSize: 12,
    textAnchor: "middle"
  }, "Timeout \uFFFD retry \uFFFD stream guard \uFFFD breaker \uFFFD Redis cap"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 520,
    width: 420,
    height: 110,
    rx: 12,
    fill: "url(#outbound)",
    stroke: "#34d399",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 554,
    fill: "#f8fafc",
    fontSize: 16,
    fontWeight: 700,
    textAnchor: "middle"
  }, "web-fetch :3007"), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 578,
    fill: "#d1fae5",
    fontSize: 13,
    textAnchor: "middle"
  }, "Adapters + orchestrator"), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 600,
    fill: "#a7f3d0",
    fontSize: 12,
    textAnchor: "middle"
  }, "Cheap HTTP first \uFFFD budget \uFFFD crawl jobs"))), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 630,
    x2: 280,
    y2: 690,
    stroke: "#64748b",
    strokeWidth: 2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "274,690 286,690 280,700",
    fill: "#64748b"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 630,
    x2: 820,
    y2: 690,
    stroke: "#64748b",
    strokeWidth: 2
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "814,690 826,690 820,700",
    fill: "#64748b"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 708,
    width: 420,
    height: 78,
    rx: 12,
    fill: "url(#vendor)",
    stroke: "#71717a",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 740,
    fill: "#f4f4f5",
    fontSize: 15,
    fontWeight: 700,
    textAnchor: "middle"
  }, "LLM vendors"), /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 762,
    fill: "#d4d4d8",
    fontSize: 13,
    textAnchor: "middle"
  }, "OpenAI \uFFFD Anthropic \uFFFD OpenRouter"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 708,
    width: 420,
    height: 78,
    rx: 12,
    fill: "url(#vendor)",
    stroke: "#71717a",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 740,
    fill: "#f4f4f5",
    fontSize: 15,
    fontWeight: 700,
    textAnchor: "middle"
  }, "Web vendors"), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 762,
    fill: "#d4d4d8",
    fontSize: 13,
    textAnchor: "middle"
  }, "Direct HTTP \uFFFD Olostep"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 848,
    fill: "#94a3b8",
    fontSize: 14
  }, "Green boxes are the only places that hold vendor credentials.")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 876,
    fill: "#94a3b8",
    fontSize: 14
  }, "Purple boxes speak internal HTTP. They do not import vendor SDKs.")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchitecture);
export default __webpack_public_path__ + "static/media/architecture.63eadd8a6e010ba517ad6a7bc3cb5614.svg";
export { ForwardRef as ReactComponent };